import React, { useState, useEffect, useMemo } from 'react';
import { Typography } from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import { useAppNavigate } from '../../Hooks/back/useAppNavigate';
import { useDispatch, useSelector } from 'react-redux';
import { BottomSheetActions } from '../../Reducer/BottomSheetReducer';
import { Button, Dialog } from '../../Components/MUIs';
import QrScanner from '../../Components/QR-Code/QR-Scanner/QrScanner';
import { Capacitor } from '@capacitor/core';
import QrCreator from '../../Components/QR-Code/QR-Creator/QrCreator';
import WorkEndBottomStheet from '../../Components/Ui/WorkEndBottomStheet';
import { NavBarInfoActions } from '../../Reducer/NavBarInfoReducer';
import { CommonActions } from '../../Reducer/CommonReducer';
import MenuCard from '../../Components/MUIs/MenuCard';
import Icon from '../../Assets/Icon/CustomIcon';
import HomeUserCard from './ui/HomeUserCard';
import Notice from './ui/Notice';
import UserDetailCard from './ui/UserDetailCard';
import { useBackStack } from '../../Hooks/back/useBackStack';
import { BackInfoActions } from '../../Reducer/BackInfoReducer';
import { showSnackbar } from '../../Reducer/SnackbarReducer';
import { TbmActions } from '../../Reducer/TbmReducer';

export const ParseGuidFromQrValue = (raw) => {
  const text = String(raw ?? '').trim();
  if (!text) return '';

  const guidOnly = text.match(
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
  );
  if (guidOnly) return guidOnly[0];

  const guidInText = text.match(
    /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/
  );
  if (guidInText) return guidInText[0];

  return '';
};

export const menuConfig = [
  // --- Drawer 전용 메뉴 ---
  {
    ids: ['M_Notice'],
    icon: Icon.Notifications,
    iconColor: '#F59E0B',
    iconBg: '#FEF3C7',
    label: '공지 사항',
  },
  {
    ids: ['Mypage'],
    icon: Icon.Setting,
    iconColor: '#64748B',
    iconBg: '#F1F5F9',
    label: '설정',
  },

  // --- 홈 메뉴 (작업/진행) ---
  {
    ids: ['M_TBMManager'],
    icon: Icon.Groups,
    iconColor: '#10B981',
    iconBg: '#DCFCE7',
  },
  {
    ids: ['M_TBM'],
    icon: Icon.Groups,
    iconColor: '#10B981',
    iconBg: '#DCFCE7',
  },
  {
    ids: ['M_TRA'],
    icon: Icon.Groups,
    iconColor: '#0EA5E9',
    iconBg: '#E0F2FE',
  },
  {
    ids: ['M_WorkInfo'],
    icon: Icon.Lightbulb,
    iconColor: '#3B82F6',
    iconBg: '#DBEAFE',
  },
  {
    ids: ['M_PPE'],
    icon: Icon.PlayCircle,
    iconColor: '#F97316',
    iconBg: '#FFEDD5',
  },
  {
    ids: ['M_WorkEnd2'],
    icon: Icon.Stop,
    iconColor: '#EF4444',
    iconBg: '#FEE2E2',
  },
  {
    ids: ['M_WorkEnd'],
    icon: Icon.ToolTip,
    iconColor: '#0D9488',
    iconBg: '#F0FDFA',
  },
  {
    ids: ['M_WorkStop/write'],
    icon: Icon.Siren,
    iconColor: '#F43F5E',
    iconBg: '#FFE4E6',
  },
  {
    ids: ['M_WorkStop/list'],
    icon: Icon.VerifiedUser,
    iconColor: '#0F172A',
    iconBg: '#E2E8F0',
  },
  {
    ids: ['M_Permit'],
    icon: Icon.TaskAlt,
    iconColor: '#8B5CF6',
    iconBg: '#EDE9FE',
  },
  {
    ids: ['M_Meeting'],
    icon: Icon.Description,
    iconColor: '#06B6D4',
    iconBg: '#ECFEFF',
  },
  {
    ids: ['M_File'],
    icon: Icon.FolderOpen,
    iconColor: '#D946EF',
    iconBg: '#FAE8FF',
  },
  {
    ids: ['M_DocsManagement'],
    icon: Icon.Inventory,
    iconColor: '#6366F1',
    iconBg: '#EEF2FF',
  },
  {
    ids: ['M_EquipIssuance'],
    icon: Icon.HardHat,
    iconColor: '#E11D48',
    iconBg: '#FFF1F2',
  },
  {
    ids: ['M_EquipIssuanceStatus'],
    icon: Icon.Engineering,
    iconColor: '#BE185D',
    iconBg: '#FCE7F3',
  },
  {
    ids: ['M_TBMCompletionStatus'], //TBM 이수현황
    icon: Icon.FormatListBulleted,
    iconColor: '#16A34A',
    iconBg: '#DCFCE7',
  },
  {
    ids: ['M_RNM'], //안전신문고 근로자 의견
    icon: Icon.RiskNearMiss,
    iconColor: '#06B6D4',
    iconBg: '#ECFEFF',
  },
  {
    ids: ['M_Guide'], //안전신문고 근로자 의견
    icon: Icon.MenuBook,
    iconColor: '#1E40AF',
    iconBg: '#DBEAFE',
  },
];

export default function Home(props) {
  const {
    ScanBarcodeTra,
    ScanBarcode,
    Save1,
    workEndUpload,
    setWorkEndInputs,
    workEndInputs,
    SaveLogic4,
    qrcode,
  } = props;
  const { navigate } = useAppNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [activeStep, setActiveStep] = useState(0);
  const [isQrScannerOpen, setIsQrScannerOpen] = useState(false);
  const [qrScannerMode, setQrScannerMode] = useState('');
  const [modalToggle1, setModalToggle1] = useState(false);

  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const { menuInfo, userInfo, lanInfo } = useSelector(
    (state) => state.BaseInfo
  );
  const { workCd } = useSelector((state) => state.workingCheck);

  // QR 스캐너 열릴 때 BackStack에 등록
  // 뒤로가기 시 스캐너 닫힘, 언마운트 시 자동 pop
  useBackStack({
    type: 'custom',
    enabled: isQrScannerOpen,
    onBack: () => {
      setIsQrScannerOpen(false);
      setQrScannerMode('');
    },
  });

  useEffect(() => {
    dispatch(TbmActions.resetTbm());
    dispatch(BackInfoActions.clear());
    dispatch(NavBarInfoActions.setType('appBarDefault'));
    dispatch(BottomSheetActions.CloseBottomSheet());
    dispatch(CommonActions.resetActiveStep());
    dispatch(NavBarInfoActions.setBgColor('#f7f8fa'));
  }, [dispatch]);

  /** MainDrawer 등에서 /Home + state.openTraQr 로 진입 시 홈 메뉴(M_TRA)와 동일하게 스캔 (웹: QrScanner / 네이티브: CapacitorBarcodeScanner) */
  useEffect(() => {
    if (!location.state?.openTraQr) return;
    if (Capacitor.isNativePlatform()) {
      ScanBarcodeTra?.();
    } else {
      setQrScannerMode('M_TRA');
      setIsQrScannerOpen(true);
    }
    navigate('.', { replace: true, state: {} });
  }, [location.state?.openTraQr, navigate, ScanBarcodeTra]);

  /** MainDrawer 등에서 /Home + state.openTbmQr 로 진입 시 홈 메뉴(M_TBM)와 동일하게 TBM 참석 QR (웹: QrScanner / 네이티브: CapacitorBarcodeScanner) */
  useEffect(() => {
    if (!location.state?.openTbmQr) return;
    if (Capacitor.isNativePlatform()) {
      ScanBarcode?.();
    } else {
      setQrScannerMode('M_TBM');
      setIsQrScannerOpen(true);
    }
    navigate('.', { replace: true, state: {} });
  }, [location.state?.openTbmQr, navigate, ScanBarcode]);

  const { menuIcons, menuIconColors, menuIconBgs } = useMemo(() => {
    const icons = {};
    const colors = {};
    const bgs = {};
    menuConfig.forEach(({ ids, icon, iconColor, iconBg }) => {
      ids.forEach((id) => {
        icons[id] = icon;
        colors[id] = iconColor;
        bgs[id] = iconBg;
      });
    });
    return { menuIcons: icons, menuIconColors: colors, menuIconBgs: bgs };
  }, []);

  const Menus = useMemo(() => {
    let menus = menuInfo
      .filter((m) => m.seq < 18 && m.seq > 0)
      .map((m) => ({
        ...m,
        style: menuIcons[m.menuId] ? { icon: menuIcons[m.menuId] } : null,
      }))
      .filter((m) => !!m.style);

    if (userInfo.authCd === 'EMPLOYEE') {
      menus = menus.filter((menu) =>
        workCd ? !menu.hideWhenWorking : !menu.requiresWorkCd
      );
    }

    return menus.slice(0, 8);
  }, [menuInfo, userInfo.authCd, workCd, menuIcons]);

  const handleMenuClick = (menuId) => {
    if (menuId === 'M_TBMManager') {
      navigate('/M_TBMSetting');
    } else if (menuId === 'M_TBM') {
      setQrScannerMode('M_TBM');
      if (Capacitor.isNativePlatform()) {
        ScanBarcode();
      } else {
        setIsQrScannerOpen(true);
      }
    } else if (menuId === 'M_TRA') {
      if (Capacitor.isNativePlatform()) {
        ScanBarcodeTra?.();
      } else {
        setQrScannerMode('M_TRA');
        setIsQrScannerOpen(true);
      }
    } else if (menuId === 'M_WorkEnd2') {
      dispatch(
        BottomSheetActions.SetBottomSheetState({
          bottom: true,
          type: 'WorkEnd',
        })
      );
    } else if (menuId === 'M_Work') {
      navigate('/M_PPE');
    } else {
      navigate(`/${menuId}`);
    }
  };

  return (
    <div className="bg-background-light flex h-full w-full flex-col">
      {isQrScannerOpen ? (
        <QrScanner
          backClick={() => {
            setIsQrScannerOpen(false);
            setQrScannerMode('');
          }}
          getCode={(e) => {
            if (e) {
              if (qrScannerMode === 'M_TBM') {
                //TBM 참석
                const payload = [{ sessionCd: e, hostYn: 'N', stayTime: 0 }];
                Save1(payload);
              } else if (qrScannerMode === 'M_TRA') {
                //안전보건교육 참석
                const scannedRaw = String(e ?? '').trim();
                const sessionId = ParseGuidFromQrValue(scannedRaw);
                if (!sessionId) {
                  dispatch(
                    showSnackbar({
                      message:
                        '유효한 교육 참석 QR(Session GUID)가 아닙니다. 다시 스캔해 주세요.',
                      type: 'warning',
                    })
                  );
                  return;
                }
                setIsQrScannerOpen(false);
                setQrScannerMode('');
                navigate(`/M_TRA/sign/${encodeURIComponent(sessionId)}`);
              }
            }
          }}
        />
      ) : (
        <main className="mb-4 grid gap-4 overflow-y-auto px-4 pt-2">
          <HomeUserCard />
          <UserDetailCard />
          <div className="grid grid-cols-4 items-start gap-2">
            {Menus.map((menu, i) => (
              <MenuCard
                key={menu.no || i}
                menuId={menu.menuId}
                IconComponent={menuIcons[menu.menuId] || Icon.Description}
                iconColor={menuIconColors[menu.menuId]}
                iconBg={menuIconBgs[menu.menuId]}
                label={menu.menuNm}
                onClick={() => handleMenuClick(menu.menuId)}
              />
            ))}
          </div>
          {menuInfo?.some((menu) => menu.seq === 997) && (
            <Notice activeStep={activeStep} setActiveStep={setActiveStep} />
          )}
        </main>
      )}

      {/* QR코드 생성 모달 */}
      {modalToggle1 && (
        <Dialog
          open={modalToggle1}
          fullWidth
          maxWidth={false}
          sx={{ height: '90vh' }}
          PaperProps={{
            className: 'm-4 rounded-2xl w-[calc(100%-32px)] max-w-full',
          }}
          useSaveButton={false}
          useSaveAfterClose={false}
          useCloseButton={false}
          onSave={() => {}}
          saveButtonName={
            lanInfo.length === 0
              ? ''
              : lanInfo.find(
                  (f) => f.lanType === 'CALL' && f.lanId === 'Choice'
                )?.lanNm
          }
          closeButtonName={
            lanInfo.length === 0
              ? ''
              : lanInfo.find((f) => f.lanType === 'CALL' && f.lanId === 'Close')
                  ?.lanNm
          }
          title={
            <div className="flex w-full items-center justify-between">
              <Typography variant="title">교육 입장을 위한 QR 코드</Typography>
              <Button
                variant="text"
                className="min-w-0 text-black"
                name={<ClearIcon />}
                onClick={() => setModalToggle1(false)}
              />
            </div>
          }
          content={
            <div className="flex flex-col items-center space-y-4">
              <QrCreator value={qrcode} />
              <Button
                className="mt-4 h-9 w-full rounded-full"
                name="작업 시작"
                onClick={() => navigate('/M21001')}
              />
            </div>
          }
        />
      )}

      {/* 작업 종료 바텀시트 - BottomSheet 공통 컴포넌트 안에서 useBackStack 처리됨 */}
      {bottomSheetState.bottom && bottomSheetState.type === 'WorkEnd' && (
        <WorkEndBottomStheet
          workEndUpload={workEndUpload}
          setWorkEndInputs={setWorkEndInputs}
          workEndInputs={workEndInputs}
          SaveLogic4={SaveLogic4}
        />
      )}
    </div>
  );
}
